import React from 'react'
import { graphql } from 'gatsby'
import Layout from '@layout'
import SEO from '@layout/SEO'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import AllContentPageInfo from './AllContentPageInfo'
import OtherOptionsMenu from '@components/OtherOptionsMenu'
import ContentGrid from '@components/ContentGrid'

export const query = graphql `
query 
{
  allPrismicContentHome{
    edges {
      node {
        uid
        id
        type
        data {
          page_title {
            text
          }
          page_description {
            text
            html
            raw
          }
        } 
      }
    }  
  } 
}
`

const AllContent = (props) => {
    const documents = props.pageContext.documents;
    const allContentPage = props.data.allPrismicContentHome.edges[0].node;
    const pageTitle = allContentPage.data.page_title.text;

    if(!documents) return null;
    if (typeof window !== "undefined"){
      return ( 
        <Layout>
        <SEO title={pageTitle} description="A page containing all of the Research Division's content" pathname={props.location.pathname}/>
        <Row>
          <Col lg={9} className="text-left">
            <AllContentPageInfo pageInfo = { allContentPage }/> 
          </Col>
          <Col lg={3} className="text-lg-right pr-lg-3 pt-2 pt-lg-0">
            <OtherOptionsMenu isAllContent={true}/>
          </Col>
        </Row>
        <hr className="my-4"/>
        <Row>
          <Col>
              <ContentGrid documents={documents}/>
          </Col>
        </Row>
        </Layout>
      
    )
    }
    else {
      return null;
    }

}

export default AllContent;